export default function () {
  return {
    pedidoTipos: {
      data: [],
    },
    pedidoTipo: {},
  };
}
